import React, { useState } from 'react';
import { toast } from 'react-toastify';
import LoadingSpinner from '../components/LoadingSpinner';
import './Services.css';

const API_BASE = process.env.REACT_APP_FILE_API_URL;

const FileDelete = () => {
  const [fileId, setFileId] = useState('');
  const [result, setResult] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleDelete = async (e) => {
    e.preventDefault();
    if (!fileId) return;
    setError('');
    setResult('');
    setLoading(true);
    try {
      await fetch(`${API_BASE}/files/user/${fileId}`, { 
        method: 'DELETE',
        headers: {
          'Authorization': 'Basic YWRtaW46YWRtaW4='
        }
      });
      setResult('File deleted successfully.');
      toast.success('File deleted successfully!');
    } catch {
      setError('Delete failed.');
      toast.error('Failed to delete file.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="service-page">
      <h1>Delete File</h1>
      <form onSubmit={handleDelete} className="file-upload-form">
        <input
          type="text"
          placeholder="Enter File ID"
          value={fileId}
          onChange={e => setFileId(e.target.value)}
          disabled={loading}
        />
        <button type="submit" disabled={loading || !fileId} className="submit-button">
          {loading ? <LoadingSpinner /> : 'Delete'}
        </button>
      </form>
      {result && <div className="service-result">{result}</div>}
      {error && <div className="file-error">{error}</div>}
      {loading && <div className="loading-overlay"><LoadingSpinner /></div>}
    </div>
  );
};

export default FileDelete;
